/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EFormePersonne {
    Apprenant = 'Apprenant',
    Representant = 'Representant',
    Formateur = 'Formateur',
    Tuteur = 'Tuteur',
    Contact = 'Contact',
    ChefEntreprise = 'ChefEntreprise'
}


export function EFormePersonneFromJSON(json: any): EFormePersonne {
    return EFormePersonneFromJSONTyped(json, false);
}

export function EFormePersonneFromJSONTyped(json: any, ignoreDiscriminator: boolean): EFormePersonne {
    return json as EFormePersonne;
}

export function EFormePersonneToJSON(value?: EFormePersonne | null): any {
    return value as any;
}

